import { useMemo } from 'react';

import { Icons } from '@/assets/icons/icons';
import { FEATURES } from '@/features/feature-flags';
import { setFeatureFlagOverride } from '@/features/feature-flags/feature-flags';
import { useIsInternalUser } from '@/hooks/useIsInternalUser';
import { userStore } from '@/stores/user.store';

import { createAction, Section } from '.';

import type { Action } from './types';

// Developer tools no customer gets: hiding overrides them off, showing drops the override
const INTERNAL_TOOL_FEATURES = [FEATURES.API_REQUEST_LOGGER, FEATURES.ARENA];

const setInternalToolsHidden = (hidden: boolean) => {
  userStore.setHideInternalTools(hidden);
  for (const feature of INTERNAL_TOOL_FEATURES) {
    setFeatureFlagOverride(feature, hidden ? false : undefined);
  }
};

/** Only accounts with internal access get it, so it stays reachable while the tools are hidden */
export const useInternalToolsActions = (): Action[] => {
  const isInternalUser = useIsInternalUser();
  const hasInternalAccess = userStore.hasInternalAccess;

  return useMemo(
    () =>
      hasInternalAccess
        ? [
            createAction({
              id: 'toggle-internal-tools',
              name: isInternalUser
                ? 'Hide internal tools'
                : 'Show internal tools',
              keywords: 'demo mode preview as user customer view internal',
              section: Section.Settings,
              icon: isInternalUser ? (
                <Icons.eyeOff size={14} />
              ) : (
                <Icons.eye size={14} />
              ),
              perform: () =>
                setInternalToolsHidden(!userStore.hideInternalTools),
            }),
          ]
        : [],
    [hasInternalAccess, isInternalUser]
  );
};
